import { BaseEntity } from '../../models';
import { regiaoSituacaoAtiva } from './situacao';
import { RegiaoCidade } from './cidade';
import { RegiaoRepresentante } from './representante';

export class Regiao implements BaseEntity {
    readonly id: number;
    idEmpresa: number;
    idEstado: number;
    codigo: number;
    nome: string;
    situacao: number;
    cidades: RegiaoCidade[];
    representantes: RegiaoRepresentante[];

    // Integração ERP
    idIntegracaoErp: number;
    dataIntegracaoErp: Date;
    dataUltimaIntegracaoErp: Date;
    codigoIntegracaoErp: string;

    constructor() {
        this.situacao = regiaoSituacaoAtiva.id;
        this.cidades = [];
        this.representantes = [];
    }
}
